import { ADD_FIELD_PROMPT_CONTEXT } from '@cli-constants/prompt-copy.js'
import { promptSelectValue as promptSchemaSelectValue } from '../schema-prompts/prompt-select-value.js'

export async function promptSelectValue<T extends string>(
  message: string,
  options: Array<{ value: T; label: string }>,
  initialValue?: T
): Promise<T> {
  return promptSchemaSelectValue(ADD_FIELD_PROMPT_CONTEXT, message, options, initialValue)
}
